jQuery(document).ready(function ($) {

	// Sticky header / scroll-to-top / landing content active states
	$(window).scroll(function () {
		if ($(window).scrollTop() > 10) {
			$("#scroll-to-top").addClass("active");
			$("#main-header").addClass("active");
			$("#landing-area-content").addClass("active");
			$("#the-landing-content").addClass("active");
		} else {
			$("#scroll-to-top").removeClass("active");
			$("#main-header").removeClass("active");
			$("#landing-area-content").removeClass("active");
			$("#the-landing-content").removeClass("active");
		}
	});

	// Mobile navigation panel
	if ($(".trigger-menu-navigation-main").length) {
		$(".trigger-menu-navigation-main").click(function (event) {
			$("#panel-main-navigation").addClass("active");
			$("#panel-overlay").addClass("active");
			$("body").addClass("active");
			event.preventDefault();
		});
	}

	if ($("#trigger-close-panel-navigation").length) {
		$("#trigger-close-panel-navigation").click(function (event) {
			$("#panel-main-navigation").removeClass("active");
			$("#panel-overlay").removeClass("active");
			$("body").removeClass("active");
			event.preventDefault();
		});
	}

	// Language selector panel
	if ($(".trigger-panel-language-selector").length) {
		$(".trigger-panel-language-selector").click(function (event) {
			$("#panel-language-selector").addClass("active");
			event.preventDefault();
		});
	}

	if ($(".trigger-close-panel-language-selector").length) {
		$(".trigger-close-panel-language-selector").click(function (event) {
			$("#panel-language-selector").removeClass("active");
			event.preventDefault();
		});
	}

	// Newsletter / Mailchimp panel
	if ($(".trigger-panel-newsletter").length) {
		$(".trigger-panel-newsletter").click(function (event) {
			$("#panel-newsletter-mailchimp").addClass("active");
			$("body").addClass("active");
			event.preventDefault();
		});
	}

	if ($(".trigger-close-panel-newsletter").length) {
		$(".trigger-close-panel-newsletter").click(function (event) {
			$("#panel-newsletter-mailchimp").removeClass("active");
			$("body").removeClass("active");
			event.preventDefault();
		});
	}

	// Overlay click closes any open panel
	if ($("#panel-overlay").length) {
		$("#panel-overlay").click(function (event) {
			$("#panel-main-navigation").removeClass("active");
			$("#panel-overlay").removeClass("active");
			$("body").removeClass("active");
			event.preventDefault();
		});
	}

	// Escape key closes panels
	$(document).on("keydown", function (event) {
		if (event.key == "Escape") {
			$("#panel-main-navigation").removeClass("active");
			$("#panel-overlay").removeClass("active");
			$("body").removeClass("active");
			event.preventDefault();
		}
	});

	// Homepage Swiper slider
	new Swiper(".swiper-container-homepage", {
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		direction: "horizontal",
		loop: true,
		freeMode: true,
		slidesPerView: "1",
		spaceBetween: 0,
		speed: 2000,
		effect: "fade",
	});

	// Homepage Swiper What's Happening
	new Swiper(".swiper-social-banners", {
		autoplay: {
			delay: 3500,
			disableOnInteraction: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		direction: "horizontal",
		loop: false,
		freeMode: true,
		slidesPerView: "1",
		spaceBetween: 40,
		speed: 2000,
		effect: "slide",
		breakpoints: {
			810: {
				slidesPerView: 2,
			},
			992: {
				slidesPerView: 4,
				spaceBetween: 20
			},
			1900: {
				slidesPerView: 6,
				spaceBetween: 20
			}
		},
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next-social-banners',
			prevEl: '.swiper-button-prev-social-banners',
		}
	});

	// Phone input mask
	$(".phone").mask("+351 000 000 000");

});
